import { render, staticRenderFns } from "./InventoryItems.vue?vue&type=template&id=8ce9b5e0&scoped=true&"
import script from "./InventoryItems.vue?vue&type=script&lang=js&"
export * from "./InventoryItems.vue?vue&type=script&lang=js&"
import style0 from "./InventoryItems.vue?vue&type=style&index=0&id=8ce9b5e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce9b5e0",
  null
  
)

export default component.exports